export class StatusInfo {
    cmstext: string = "";
    status: string = "";
}